import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

import { cn } from "@/shared/lib";

import type { HeroView } from "../../api/useHeroLookup";
import { HeroAvatar } from "../HeroAvatar";

const LABEL = msg({
  message: "{hero}: {games, plural, one {# match} other {# matches}}",
});

type HeroFilterTileProps = {
  hero: HeroView;
  games: number;
  isSelected: boolean;
  onToggle: (heroId: number) => void;
};

// Герой в выборе героев: иконка, сколько матчей на нём, отметка выбранного.
// Героя, на котором игрок не играл, видно серым и без счётчика.
export const HeroFilterTile = ({ hero, games, isSelected, onToggle }: HeroFilterTileProps) => {
  const { i18n } = useLingui();
  return (
    <button
      type="button"
      aria-pressed={isSelected}
      aria-label={games > 0 ? i18n._({ ...LABEL, values: { hero: hero.name, games } }) : hero.name}
      title={hero.name}
      onClick={() => {
        onToggle(hero.id);
      }}
      className={cn(
        "flex w-full min-w-0 cursor-pointer flex-col items-center gap-1.5 rounded-[10px] border-2 bg-surface-raised px-1 pt-2 pb-1.5 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-accent/60",
        isSelected
          ? "border-accent text-foreground"
          : cn(
              "border-transparent hover:border-border",
              games > 0 ? "text-foreground-soft" : "text-subtle",
            ),
      )}
    >
      <span className="relative block">
        <HeroAvatar
          name={hero.name}
          iconUrl={hero.iconUrl}
          size={48}
          className={cn(
            "rounded-[10px]",
            games === 0 && !isSelected && "opacity-60 grayscale-[0.7]",
          )}
        />
        {isSelected && (
          <span
            aria-hidden="true"
            className="absolute -top-1.5 -right-1.5 inline-flex size-5 items-center justify-center rounded-full border-2 border-surface bg-accent text-xs font-bold text-accent-foreground"
          >
            ✓
          </span>
        )}
        {games > 0 && (
          <span
            aria-hidden="true"
            className="absolute -bottom-1 -left-1 min-w-[18px] rounded-full border border-border bg-background px-1 text-center font-mono text-[11px] leading-4 text-foreground-soft"
          >
            {games}
          </span>
        )}
      </span>
      <span className="max-w-full truncate text-[11px] leading-tight">{hero.name}</span>
    </button>
  );
};
